export default __webpack_public_path__ + "static/media/interactiondesign-amico.0e75d696.svg";